import type { AuthOptions } from "next-auth"
import { authOptionsCookies } from "./auth-options-cookies";

export const authOptionsSession: AuthOptions = {
  providers: [],
  cookies:   authOptionsCookies,
  callbacks: {
    async session({ session, token }) {
      if (session?.user) {
        session.user.id          = token.uid;
        session.user.role        = token.role;
        session.user.testingTags = token.testingTags;
        session.user.currentUser = token.currentUser;
        session.user.superUser   = token.superUser;
      }

      return session;
    },
  },
}
